import React, { Component } from "react";
import { Switch, Route } from "react-router-dom";
import SatisfactionSurveysIndex from "components/SatisfactionSurveys/SatisfactionSurveysIndex";
import SatisfactionSurveysEdit from "components/SatisfactionSurveys/SatisfactionSurveysEdit";
import SatisfactionCustomAudienceEdit from "components/SatisfactionSurveys/SatisfactionCustomAudienceEdit";

class SatisfactionSurveys extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <Switch>
        <Route
          path="/nps/:satisfactionId/edit"
          component={SatisfactionSurveysEdit}
        />
        <Route
          path="/nps/:ruleId/settings"
          component={SatisfactionCustomAudienceEdit}
        />
        <Route path="/nps" component={SatisfactionSurveysIndex} />
      </Switch>
    );
  }
}

export default SatisfactionSurveys;
